import { defineStore } from "pinia";
import { useBase } from "@/utils/stores/base";

const storeName = "organization";

export const useOrganizationStore = defineStore(storeName, () => {
  const { baseFetchOne, baseSave } = useBase(storeName);

  const fetchOne = async (id, errorCallback) => {
    return await baseFetchOne("organizations", id, errorCallback);
  };

  const update = async (id, attributes, callback, errorCallback) => {
    return await baseSave("organizations", { id, attributes }, callback, errorCallback);
  };

  return {
    fetchOne,
    update,
  };
});
